import './components/prism';
import './components/smoothScroll';

import ArticleNav from './components/sidebarNavigation';
import {Tabs, ComponentsTabs, TeamTabs} from './components/tabs';
import GenerateQR from './components/qr';
import Lightbox from './components/imageLightbox';
import Video from './components/iframe';
import ComponentsSearch from './components/componentsSearch';
import FeedbackForm from './components/feedbackForm';
import Compatibility from './components/compatibility';
import Results from './components/searchResults';
import AnalyticsGlossary from './components/analyticsGlossary';
import Tooltip from './components/tooltip';
import PartnersTable from './components/searchableTables';

const changelog = document.querySelector('.changelog');
const contentTabs = document.querySelector('.content-tabs');
const components = document.querySelector('.components');
const teamTabs = document.querySelector('.team-tabs');

GenerateQR.init();
Video.init();

window.addEventListener('DOMContentLoaded', () => {
    ArticleNav.init();
    Lightbox.init();
    AnalyticsGlossary.init();
    FeedbackForm.init();
    Tooltip.init();
    Results.init();
    Compatibility.init();
    PartnersTable.init();

    new Tabs(changelog);
    new Tabs(contentTabs);
    new TeamTabs(teamTabs);

    if (components) {
        new ComponentsSearch(components);
        new ComponentsTabs(components);
    }
})
